import {IFCLoader} from 'three/examples/jsm/loaders/IFCLoader';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {OBJLoader} from 'three/examples/jsm/loaders/OBJLoader';
import {ColladaLoader} from "three/examples/jsm/loaders/ColladaLoader";
import {scene} from "../sceneManager";
import * as THREE from "three";
import {Box3} from "three";

export const gltfLoader = new GLTFLoader();
export const objLoader = new OBJLoader();
export const ifcLoader = new IFCLoader();
export const colladaLoader = new ColladaLoader();
const bufferGeometryLoader = new THREE.BufferGeometryLoader();
ifcLoader.ifcManager.setWasmPath("ifc/");

export function loadModel(loader, url) {
    return new Promise((resolve, reject) => {
        loader.load(url, data => resolve(data), null, reject);
    });
}

export function importFile(input) {
    let files = input.files;
    console.log(files);
    if (files.length === 0) {
        console.warn("No file selected");
        return;
    }

    //Read file from input => Import selected file (.gltf / .obj / .ifc)
    let reader = new FileReader();
    reader.onload = function (e) {
        if (e.target.result) {
            let extension = files[0].name.split('.').pop().toLowerCase();
            let url = URL.createObjectURL(files[0]);

            if (extension === "gltf") {
                gltfLoader.load(url, function (gltf) {
                    scene.addWithUuid(gltf.scene);
                });
            } else if (extension === "ifc") {
                ifcLoader.load(url, function (ifcModel) {
                    scene.addWithUuid(ifcModel);
                });
            } else if (extension === "obj") {
                objLoader.load(url, function (objModel) {
                    scene.addWithUuid(objModel);
                });
            }
        }
    };
    reader.readAsArrayBuffer(files[0]);
}

export function cleanUpColladaModel(object) {
    if (object.children !== undefined) {
        for (let i = object.children.length - 1; i >= 0; i--) {
            let child = object.children[i];
            if (child.type === "LineSegments" || child.type === "PerspectiveCamera" || new Box3().setFromObject(child).isEmpty()) {
                child.removeFromParent();
            } else {
                cleanUpColladaModel(child);
            }
        }
    }
}

export function storeBufferGeometry(mesh) {
    if (mesh.geometry.index !== null) {
        return mesh.geometry.toNonIndexed().toJSON();
    } else {
        return mesh.geometry.toJSON();
    }
}

export function loadBufferGeometry(geometry) {
    return bufferGeometryLoader.parse(geometry);
}
